import fp from 'lodash/fp';
import React from 'react';
import queryString from 'query-string';
import { format } from 'date-fns';
import { Breadcrumb, BreadcrumbItem } from "react-bootstrap";
import connect from "react-redux/lib/connect/connect";
import { LinkContainer } from "react-router-bootstrap";
import { branch, compose, lifecycle, renderComponent, withProps } from "recompose";
import { bindActionCreators } from "redux";
import { routes, dateFormats } from "../../../../constants";
import { fullName, getDefaultProgressLabel, getManagedTeam, isTeamManager, startOfNextCpdPeriod, startOfThisCpdPeriod } from "../../../../services";
import { businessActions, businessSelector } from "../../../../state/modules/business";
import { currentUserSelector } from '../../../../state/modules/user';
import Loading from '../../../pages/loading';
import ProgressReport from '../../shared/progress-report';

const reportBreadCrumb = (userName, currentUser, business) =>
  <Breadcrumb>
    <LinkContainer to={isTeamManager(currentUser, business) ? routes.app.teams.teamMembers(getManagedTeam(currentUser)) : routes.app.teams.root}>
      <BreadcrumbItem>
        {isTeamManager(currentUser, business) ? 'Team' : 'Teams'}
      </BreadcrumbItem>
    </LinkContainer>
    <BreadcrumbItem active>
      {userName} Progress report
      </BreadcrumbItem>
  </Breadcrumb>

const mapStateToProps = ({ business, industry, user, ...state }, { reporteeId, reporteeTeamId }) => ({
  afsLicence: business.afsLicences && business.afsLicences[0],
  business: businessSelector({ business }),
  industryCpdCategorys: industry.cpdCategorys,
  cpdActivity: fp.get('userCpdPoints')(business.cpdActivities),
  currentUser: currentUserSelector(state),
  reportee: fp.find(({ user }) => user.id === reporteeId)(
    reporteeTeamId ?
      fp.get('members')(business.team.currentTeam) :
      business.teamMembers
  ),
  cpdCategoryProgress: business.memberCpdCategorys,
  defaultProgressLabel: getDefaultProgressLabel(user.profile),
});

const mapDispatchToProps = (dispatch) => ({
  getTeamMembers: bindActionCreators(businessActions.business.getTeamMembers, dispatch),
  getTeam: bindActionCreators(businessActions.business.team.getTeam, dispatch),
  fetchUserCpdCategorys: bindActionCreators(businessActions.business.user.getCpdCategorys, dispatch),
  fetchCpdActivities: bindActionCreators(businessActions.business.user.getCpdActivities, dispatch)
});

export default compose(
  withProps(({
    match: {
      params: {
        team,
        user
      }
    }
  }) => ({
    reporteeTeamId: parseInt(team, 10),
    reporteeId: parseInt(user, 10)
  })),
  withProps(() => {
    const parsed = queryString.parse(window.location.search);
    return ({
      showCpdPeriodSelect: true,
      yearsFromNow: Math.min(parseInt(parsed.yearsFromNow, 10) || 0, 0),
    })
  }),
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ business, industryCpdCategorys }) => !business || !industryCpdCategorys || industryCpdCategorys.length === 0,
    renderComponent(Loading)
  ),
  lifecycle({
    componentDidMount() {
      const {
        business,
        reporteeId,
        fetchUserCpdCategorys,
        yearsFromNow,
      } = this.props

      fetchUserCpdCategorys(business.id, reporteeId, { yearsFromNow });
    }
  }),
  withProps(
    ({ cpdCategoryProgress }) => ({
      cpdDaysRemaining: fp.get('primaryStat.cpdRemainingDays')(cpdCategoryProgress)
    })
  ),
  branch(
    ({ reportee, cpdDaysRemaining }) => !reportee || cpdDaysRemaining === undefined,
    renderComponent(Loading)
  ),
  withProps(({ cpdDaysRemaining, reportee, industryCpdCategorys }) => ({
    filter: {
      fromDate: format(startOfThisCpdPeriod(cpdDaysRemaining, fp.get('industryUser.months')(reportee)), dateFormats.FilteringDate),
      toDate: format(startOfNextCpdPeriod(cpdDaysRemaining), dateFormats.FilteringDate),
      cpdCategorys: fp.map('id')(industryCpdCategorys).join(',')
    }
  })),
  lifecycle({
    componentDidMount() {
      const {
        business,
        reporteeId,
        reporteeTeamId,
        getTeam,
        getTeamMembers,
        fetchCpdActivities,
        filter
      } = this.props;

      if (reporteeTeamId) {
        getTeam(business.id, reporteeTeamId);
      } else {
        getTeamMembers(business.id);
      }

      fetchCpdActivities(business.id, reporteeId, filter);
    }
  }),
  withProps(({ reportee, currentUser, business }) => ({
    user: fp.get('user')(reportee),
    reportBreadCrumb: reportBreadCrumb(fullName(fp.get('user')(reportee)), currentUser, business)
  }))
)(ProgressReport)


// WEBPACK FOOTER //
// ./src/containers/pages/app/teams/team-member-report.js